import React from 'react';
import GlobalStyle from './GlobalStyle';
import { ThemeProvider } from 'styled-components/macro';
import { BrowserRouter as Router } from 'react-router-dom';
import defaultTheme from './themes';
import { Container, Canvas, Content } from './components/landing/Landing';
import { PreferencesProvider } from './contexts/preferences';
import ScrollToTop from './ScrollToTop';
import Header from './components/landing/Header';
import Footer from './components/landing/Footer';

function App() {
  return (
    <React.Fragment>
      <GlobalStyle />

      <ThemeProvider theme={defaultTheme}>
        <Router>
          <PreferencesProvider inGame>
            <ScrollToTop />

            <Container>
              <Header />
              <Canvas>
                <Content />
              </Canvas>
              <Footer />
            </Container>
          </PreferencesProvider>
        </Router>
      </ThemeProvider>
    </React.Fragment>
  );
}

export default App;
